import { buildCollection, EntityCallbacks } from "@firecms/core";
import {
  getFirestore,
  collection,
  getDocs,
  writeBatch,
} from "firebase/firestore";

const templatesCallbacks: EntityCallbacks = {
  onPreSave: ({ values, status }) => {
    if (status === "new") {
      updateTemplateCollectionRandomizationLogic();
    }
    return values;
  },
  onPreDelete: ({ entity }) => {
    updateTemplateCollectionRandomizationLogic();
    return true;
  },
};

function updateTemplateCollectionRandomizationLogic() {
  const firestore = getFirestore();

  (async () => {
    const templatesRef = collection(firestore, "template");
    const templatesSnapshot = await getDocs(templatesRef);

    const batch = writeBatch(firestore);
    let index = 0;

    templatesSnapshot.forEach((doc) => {
      console.log(doc.id, doc.data());
      batch.update(doc.ref, {
        _randomIndex: index,
        _randomLength: templatesSnapshot.size,
      });
      index++;
    });

    await batch.commit();
    console.log("Updated _randomIndex for all templates.");
  })();
}
export const templateCollection = buildCollection({
  id: "template",
  name: "Template",
  path: "template",
  icon: "extension",
  group: "Template",
  textSearchEnabled: true,
  callbacks: templatesCallbacks,
  properties: {
    title: {
      dataType: "string",
      name: "Internal Title",
      validation: {
        required: true,
        unique: true,
        trim: true,
      },
    },
    preview_title: {
      dataType: "string",
      name: "Preview Title",
      validation: {
        required: true,
        trim: true,
      },
    },
    preview_secondary_title: {
      dataType: "string",
      name: "Preview Secondary Title",
      validation: {
        trim: true,
      },
    },
    ideal_width: {
      dataType: "number",
      name: "Ideal Width",
      validation: {
        required: true,
        min: 0,
        integer: true,
      },
      defaultValue: 570,
    },
    header_style: {
      dataType: "reference",
      name: "Header Style",
      path: "header_style",
      validation: {
        required: true,
      },
    },
    card_style: {
      dataType: "reference",
      name: "Card Style",
      path: "card_style",
      validation: {
        required: true,
      },
    },
    background_style: {
      dataType: "reference",
      name: "Background Style",
      path: "background_style",
      validation: {
        required: true,
      },
    },
    thumbnail: {
      dataType: "string",
      name: "Thumbnail",
      description: "Must include a 9x16 thumbnail image",
      storage: {
        storagePath: "/image/board/thumbnail",
        acceptedFiles: ["image/*"],
        maxSize: 1 * 1024 * 1024,
        fileName: "{rand}_{file}",
      },
      validation: {
        required: true,
      },
    },
    default_game_options: {
      name: "Game Options",
      dataType: "array",
      of: {
        dataType: "reference",
        path: "game_options",
      },
      validation: {
        required: true,
      },
    },
    product_identifier: {
      dataType: "string",
      name: "Product Identifier",
      validation: {
        lowercase: true,
        trim: true,
      },
    },
    category: {
      dataType: "string",
      name: "Category",
      validation: {
        required: true,
        trim: true,
      },
      enumValues: {
        basic: "basic",
        regular: "regular",
        premium: "premium",
      },
    },
    tags: {
      dataType: "array",
      name: "Tags",
      of: {
        dataType: "string",
        validation: {
          lowercase: true,
          unique: true,
        },
      },
    },
    sort_index: {
      dataType: "number",
      name: "Sort Index",
      validation: {
        integer: true,
      },
    },
  },
});
